// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1FeSC","ranges":"BmiRanges_ranges__3tyya"};